import { render, staticRenderFns } from "./FeTabsComponentHref.vue?vue&type=template&id=47ae43d7&scoped=true&"
import script from "./FeTabsComponentHref.vue?vue&type=script&lang=js&"
export * from "./FeTabsComponentHref.vue?vue&type=script&lang=js&"
import style0 from "./FeTabsComponentHref.vue?vue&type=style&index=0&id=47ae43d7&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47ae43d7",
  null
  
)

export default component.exports